import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var floatingCallToActionBehavior = function floatingCallToActionBehavior() {
  Alpine.data('floatingCallToAction', function () {
    return {
      isShiftedUp: false,
      init: function init() {
        this.isShiftedUp = false;
      },
      calculateShift: function calculateShift() {
        this.isShiftedUp = window.pageYOffset > window.innerHeight;
      },
      bindCtaIsShifted: {
        '@resize.window.stop.debounce': function resizeWindowStopDebounce() {
          this.calculateShift();
        },
        '@scroll.window': function scrollWindow() {
          this.calculateShift();
        },
        ':class': function _class() {
          return {
            '-translate-y-20': this.isShiftedUp
          };
        }
      }
    };
  });
};